import script from "./GroupSurveys.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupSurveys.vue?vue&type=script&setup=true&lang=js"

import "./GroupSurveys.vue?vue&type=style&index=0&id=0b35f71c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b35f71c"]])

export default __exports__